const styles = {
  root: {
    pt: { xs: 4, md: 9 },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    rowGap: 3,
  },
  herotitle: {
    fontWeight: 900,
    fontSize: '40px',
    lineHeight: '44px',
    maxWidth: '780px',
    color: 'common.black',
  },
  title: {
    fontWeight: 600,
    marginBottom: 3,
  },
  subtitle: {
    maxWidth: '416px',
    '&.MuiTypography-root': {
      color: 'text.primaryDark',
    },
  },
  mainBanner: {
    width: '100%',
    display: { xs: 'none', md: 'block' },
  },
  mainBannerMobile: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  cts: {
    flexDirection: 'column',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}

export default styles
